import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Img = styled.img`
  width: ${({ width }) => width}px;
  height: auto;
  padding: ${({ padding }) => padding}px;
  margin: ${({ margins }) => spreadForAllDirections(margins)};
  src: ${({ src }) => src};
`;

Img.defaultProps = {
  width: '50',
  height: 'auto',
  padding: 0,
  margins: [0, 0, 0, 0],
};

Img.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  padding: PropTypes.number,
  margins: PropTypes.array,
  src: PropTypes.string.isRequired,
};

const spreadForAllDirections = array => {
  return `${array.join('px ')}px`;
};

export default Img;
